const awsmobile =  {
    "aws_appsync_graphqlEndpoint": "https://wspse75rsneuloy7g2nfwttrv4.appsync-api.ap-northeast-2.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-7cc27guybrfelkvp4yt2luzxna",
};

export default awsmobile;
